var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-block"},[_c('input',{staticClass:"table-search",attrs:{"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.filterData($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }